import { render, staticRenderFns } from "./ChallengeParticipants.vue?vue&type=template&id=195e7d23&scoped=true"
import script from "./ChallengeParticipants.vue?vue&type=script&lang=js"
export * from "./ChallengeParticipants.vue?vue&type=script&lang=js"
import style0 from "./ChallengeParticipants.vue?vue&type=style&index=0&id=195e7d23&prod&lang=scss&scoped=true"
import style1 from "./ChallengeParticipants.vue?vue&type=style&index=1&id=195e7d23&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195e7d23",
  null
  
)

export default component.exports